import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import useIsMobile from "@/hooks/useIsMobile";
import { cn } from "@/lib/utils";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { ReactNode, type CSSProperties } from "react";
interface ResponsiveModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
  contentClass?: string;
  contentStyle?: CSSProperties;
  /** Overrides the inner card (bg, padding). Desktop maps to DialogContent.innerClassName; mobile replaces the Drawer padding wrapper. */
  innerClass?: string;
  /** Extra classes for the backdrop overlay (e.g. higher z-index for stacked modals). */
  overlayClassName?: string;
  hideCloseButton?: boolean;
  preventCloseOnOutsideClick?: boolean;
}
export default function ResponsiveModal(t0) {
  const $ = _c(32);
  const {
    open,
    onOpenChange,
    title,
    children,
    contentClass,
    contentStyle,
    innerClass,
    overlayClassName,
    hideCloseButton,
    preventCloseOnOutsideClick
  } = t0;
  const isMobile = useIsMobile();
  if (isMobile) {
    let t1;
    if ($[0] !== title) {
      t1 = <VisuallyHidden><DrawerTitle>{title}</DrawerTitle></VisuallyHidden>;
      $[0] = title;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== contentClass || $[3] !== innerClass) {
      t2 = cn("px-5 pb-10 pt-5", contentClass, innerClass);
      $[2] = contentClass;
      $[3] = innerClass;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== children || $[6] !== contentStyle || $[7] !== t2) {
      t3 = <div className={t2} style={contentStyle}>{children}</div>;
      $[5] = children;
      $[6] = contentStyle;
      $[7] = t2;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== overlayClassName || $[10] !== t3) {
      t4 = <DrawerContent overlayClassName={overlayClassName}>{t3}</DrawerContent>;
      $[9] = overlayClassName;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] !== onOpenChange || $[13] !== open || $[14] !== t1 || $[15] !== t4) {
      t5 = <Drawer open={open} onOpenChange={onOpenChange}>{t1}{t4}</Drawer>;
      $[12] = onOpenChange;
      $[13] = open;
      $[14] = t1;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t1;
  if ($[17] !== title) {
    t1 = <VisuallyHidden><DialogTitle>{title}</DialogTitle></VisuallyHidden>;
    $[17] = title;
    $[18] = t1;
  } else {
    t1 = $[18];
  }
  let t2;
  if ($[19] !== children || $[20] !== contentClass || $[21] !== contentStyle || $[22] !== hideCloseButton || $[23] !== innerClass || $[24] !== overlayClassName || $[25] !== preventCloseOnOutsideClick) {
    t2 = <DialogContent className={contentClass} style={contentStyle} innerClassName={innerClass} overlayClassName={overlayClassName} hideCloseButton={hideCloseButton} preventCloseOnOutsideClick={preventCloseOnOutsideClick}>{children}</DialogContent>;
    $[19] = children;
    $[20] = contentClass;
    $[21] = contentStyle;
    $[22] = hideCloseButton;
    $[23] = innerClass;
    $[24] = overlayClassName;
    $[25] = preventCloseOnOutsideClick;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  let t3;
  if ($[27] !== onOpenChange || $[28] !== open || $[29] !== t1 || $[30] !== t2) {
    t3 = <Dialog open={open} onOpenChange={onOpenChange}>{t1}{t2}</Dialog>;
    $[27] = onOpenChange;
    $[28] = open;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  return t3;
}